const TemplateLanguage = {
   
    Job_Templates:"Job Templates"
  };
  export default TemplateLanguage;
  